import Router from 'vue-router'

import Vue from 'vue'

import Parent from './components/Parent.vue'
import DayOne from './components/DayOne.vue'
import Welcome from './components/Welcome.vue'
import Datenschutz from './components/Datenschutz.vue'
import Impressum from './components/Impressum.vue'
import LoLTools_Basic from './components/LoLTools_Basic.vue'
import LoLTools_Configurator from './components/LoLTools_Configurator.vue'
import PageNotFound from './components/PageNotFound.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            name: 'welcome',
            path: '/',
            component: Welcome,
            meta: {
                icon: 'pg-home',
                text: 'Home',
                full_height: true
            }
        },
        {
            name: 'dayone',
            path: '/dayone',
            component: DayOne,
            meta: {
                icon: 'fas fa-dollar-sign',
                text: 'DayOne',
                menu_hide: true
            }
        },
        {
            name: 'lol_tools',
            path: '/lol-tools/',
            component: Parent,
            meta: {
                icon: 'fas fa-dragon',
                text: 'LOL Tools',
            },
            children: [
                {
                    name: 'lol_tools_base',
                    path: '/lol-tools/lolstats',
                    component: LoLTools_Basic,
                    meta: {
                        icon: 'fas fa-chart-line',
                        text: 'LOL Stats',
                    }
                },
                {
                    name: 'lol_tools_configurator',
                    path: '/lol-tools/lolstats-configurator',
                    component: LoLTools_Configurator,
                    meta: {
                        icon: 'fas fa-cog',
                        text: 'LOL Stats - Configurator',
                    }
                }
            ]
        },
        {
            name: 'legal_info',
            path: '/legal/',
            component: Parent,
            meta: {
                icon: 'fas fa-paragraph',
                text: 'Legal Info',
            },
            children: [
                {
                    name: 'dataprotection',
                    path: '/legal/dataprotection',
                    component: Datenschutz,
                    meta: {
                        icon: 'fas fa-lock',
                        text: 'Data Protection',
                    }
                },
                {
                    name: 'imprint',
                    path: '/legal/imprint',
                    component: Impressum,
                    meta: {
                        icon: 'fas fa-user-friends',
                        text: 'Imprint',
                    }
                },
            ]
        },
        {
            name: 'notfound',
            path: "*",
            component: PageNotFound,
            meta: {
                menu_hide: true
            }
        }
    ]
})
